import {useParams} from "react-router-dom";
import {WikiDocument} from "../../../components/wiki/wiki_document";

/** Lectura de cualquier página visible de la wiki: /app/employee/wiki/:section/:code. */
const EmployeeWikiRender = () => {
	const params = useParams();
	return <WikiDocument code={params["code"] || ""} section={params["section"] || ""}/>;
};

export default EmployeeWikiRender;
